var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Progress", { attrs: { active: _vm.progressActive } }),
      _c("div", { staticClass: "popup main_01" }, [
        _c("div", { staticClass: "popup_container" }, [
          _c("header", { staticClass: "popup_header" }, [_vm._v("안 내")]),
          _vm._m(0),
          _c("div", { staticClass: "popup_button" }, [
            _c(
              "button",
              {
                staticClass: "btn_large",
                on: {
                  click: function($event) {
                    return _vm.$router.replace("/main")
                  }
                }
              },
              [_vm._v("확 인")]
            )
          ])
        ]),
        _c("div", { staticClass: "dimBg" })
      ]),
      _c("div", { staticClass: "popup main_02" }, [
        _c("div", { staticClass: "popup_container" }, [
          _c("header", { staticClass: "popup_header" }, [_vm._v("안 내")]),
          _vm._m(1),
          _c("div", { staticClass: "popup_button" }, [
            _c(
              "button",
              {
                staticClass: "btn_large",
                on: {
                  click: function($event) {
                    return _vm.$router.replace("/main")
                  }
                }
              },
              [_vm._v("확 인")]
            )
          ])
        ]),
        _c("div", { staticClass: "dimBg" })
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_content" }, [
      _c("p", [_vm._v("유효하지 않는 기획전입니다.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_content" }, [
      _c("p", [_vm._v("선물 생성에 오류가 발생했습니다.")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }